<template>
  <BaseNoticeItem
    :button-text="$t('Learn more')"
    button-url="https://help.worksome.dk/en/articles/3669299-worksome-s-ir35-guide-for-freelancers"
    info
  >
    <template #head>
      <strong v-if="determination === 'ir35'">This contract is INSIDE IR35</strong>
      <strong v-else>This contract has the Worker Classification: "Employee"</strong>
    </template>
    <template #icon>
      <DeterminationLogo :determination="determination" :size="50" />
    </template>
    <template #body>
      <p>
        Because of this, you will be classed as employed for tax purposes for this Engagement and
        your earnings will be subjected to the same level of tax and national insurance as if you
        were an employee.
      </p>

      <template v-if="employmentCostCompliance?.isApplicable ?? false">
        <p>
          <strong>{{ hire.company.name }}</strong>
          <span v-if="employmentCost === 'ontop'">
            will pay any additional taxes on top of the freelancer's bills.
          </span>
          <span v-else>
            expect taxes to be paid by the freelancer themselves out of the already billed amount.
          </span>
        </p>
      </template>
    </template>
  </BaseNoticeItem>
</template>

<script>
import gql from 'graphql-tag'
import { computed } from 'vue'
import BaseNoticeItem from '@/components/BaseNoticeItem.vue'
import DeterminationLogo from '@/components/compliances/Determinations/DeterminationLogo.vue'
import { ComplianceName } from '@/components/compliances/types/ComplianceName.enum'

export const complianceNames = [ComplianceName.EMPLOYMENT_COST]

export const fragments = {
  hire: gql`
    fragment AcceptDeterminationCompletedNoticeHire on Hire {
      company {
        name
      }
    }
  `,
}

export default {
  name: 'AcceptDeterminationCompletedNotice',
  components: {
    BaseNoticeItem,
    DeterminationLogo,
  },
  props: {
    complianceData: {
      type: Object,
      required: true,
    },
    compliances: {
      type: Array,
      required: true,
    },
    hire: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const determination = computed(() => props.complianceData.determination)

    const employmentCostCompliance = computed(
      () =>
        props.compliances.find(
          (compliance) => compliance.name === ComplianceName.EMPLOYMENT_COST,
        ) ?? null,
    )
    const employmentCost = computed(() => employmentCostCompliance.value?.data.employmentCost)

    return {
      determination,
      employmentCost,
      employmentCostCompliance,
    }
  },
}
</script>
